<template>
  <div class="search ">
    <div class="search-content">
      <van-icon class="iconfont search-icon" class-prefix="icon" name="sousuo" size="20px"/>
      <div class="search-control">
        <form action="javascript:void(0)"><input type="search" :placeholder="placeholderText" @input="inputValue" v-model="searchVal"/></form>
      </div>
    </div>
  </div>
</template>

<script>
import {debounce} from 'lodash-es'
import store from "@/store";
export default {
  name: "Search",
  props:['keyword'],
  data(){
    return {
      placeholderText:"请输入搜索关键词",
      showIcon:true,
      searchVal:''
    };
  },
  methods:{
    search(){
      this.$emit("onSearchInput",this.searchVal)
    },
    inputValue() {
      this.$emit('setKeyword', this.searchVal)
    }
  },
  created() {
    let that = this;
    this.searchVal = this.keyword
    document.addEventListener('keydown',function(event){
      if(event.keyCode == 13) {
        that.search();
      }
    },{ passive: true })
  },
  destroyed(){
    document.removeEventListener('keydown', this.handleScroll)
  }
}
</script>

<style scoped lang="scss">
  @import "~@/assets/css/theme/theme.scss";
  .search-content {
    height: 28px;
    padding: 0 10px;
    border-radius: 14px;
    border: 1px solid #fff;
    background: inherit;
    display: flex;
    flex-direction: row;
    align-items: center;
    .search-icon {
      width: 28px;
      height: 28px;
      color: #fff;
      display: flex;
      align-items: center;
      text-align: right;
    }

    .search-control {
      height: 100%;
      color: #fff;
      flex: 1;

      form {
        height: 100%;

        input {
          width: 100%;
          height: 28px;
          line-height: 28px;
          border: none;
          float: left;
          color: #fff;
          background: unset;
          -webkit-appearance: none;
          appearance: none;
          -moz-appearance: none;
          @extend .font14;

          &::-webkit-input-placeholder,
          &:-moz-placeholder,
          &::-moz-placeholder,
          &:-ms-input-placeholder {
            font-size: inherit;
            color: #fff;
          }

          &::-webkit-search-cancel-button {
            -webkit-appearance: none;
            background: #ffffff;
            color: #ffffff;
          }

          &::-ms-clear {
            display: none;
          }
        }
      }
    }
  }

  ::-webkit-input-placeholder { /* WebKit browsers */
    color: #ffffff;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #ffffff;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #ffffff;
  }
</style>
